import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from '@sshop/i18n';

import {
  initializeAnalytics,
  setTrackingConsent,
  trackPageView,
  trackingConsentChoice,
} from '@/shared/lib/analytics';

export function Analytics() {
  const { t } = useTranslation();
  const location = useLocation();
  const [choice, setChoice] = useState<'granted' | 'denied' | null>(() => trackingConsentChoice());

  useEffect(() => {
    initializeAnalytics();
  }, []);
  useEffect(() => {
    trackPageView(`${location.pathname}${location.search}`);
  }, [location.pathname, location.search]);

  if (choice !== null) return null;
  return (
    <section
      className="border-border-strong bg-bg-canvas text-fg-primary z-toast fixed inset-x-3 bottom-3 isolate mx-auto max-w-3xl rounded-xl border p-4 opacity-100 shadow-[0_20px_55px_rgba(0,0,0,0.28)] ring-1 ring-black/10"
      role="dialog"
      aria-live="polite"
      aria-label={t('cookies.preferences')}
    >
      <p className="text-fg-secondary text-sm">
        {t('cookies.description')}
      </p>
      <div className="mt-3 flex flex-wrap justify-end gap-2">
        <button
          type="button"
          className="border-border-strong bg-bg-canvas text-fg-primary hover:bg-bg-subtle rounded-lg border px-4 py-2 text-sm font-semibold transition-colors"
          onClick={() => {
            setTrackingConsent(false);
            setChoice('denied');
          }}
        >
          {t('cookies.reject')}
        </button>
        <button
          type="button"
          className="bg-accent text-accent-fg hover:bg-accent-hover rounded-lg px-4 py-2 text-sm font-semibold transition-colors"
          onClick={() => {
            setTrackingConsent(true);
            setChoice('granted');
          }}
        >
          {t('cookies.accept')}
        </button>
      </div>
    </section>
  );
}
